import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPlus,
  faPen,
  faTimes,
  faTrashAlt,
  faUserCircle,
  faQuestionCircle,
  faArrowLeft,
  faHome,
  faSearch,
  faKey,
  faMobileAlt,
  faSignOutAlt,
  faSignInAlt,
  faFileAlt,
  faDownload,
  faSave,
  faEdit,
  faCheck,
  faEyeSlash,
  faEye,
  faEyeDropper,
  faUpload,
  faBlind,
  faBookmark,
  faMinusCircle,
  faEnvelopeOpenText,
  faAlignJustify,
  faTh,
  faChartBar,
  faMailBulk,
  faEnvelope,
  faBook,
  faFilePdf,
  faHandshakeAltSlash,
  faRedoAlt

} from '@fortawesome/free-solid-svg-icons'

export default {
  install (Vue) {
    Vue.component('font-awesome-icon', FontAwesomeIcon)
    library.add(
      faPlus,
      faPen,
      faTimes,
      faTrashAlt,
      faUserCircle,
      faQuestionCircle,
      faArrowLeft,
      faHome,
      faSearch,
      faKey,
      faMobileAlt,
      faSignOutAlt,
      faSignInAlt,
      faFileAlt,
      faDownload,
      faSave,
      faEdit,
      faCheck,
      faEyeSlash,
      faEye,
      faEyeDropper,
      faUpload,
      faBlind,
      faBookmark,
      faMinusCircle,
      faEnvelopeOpenText,
      faAlignJustify,
      faTh,
      faChartBar,
      faMailBulk,
      faEnvelope,
      faBook,
      faFilePdf,
      faHandshakeAltSlash,
      faRedoAlt
    )
  }
}
